import React, { useEffect } from "react";
import Sidebar from "../../components/sidebar";
import Header from "../../components/header";
import { useRef, useState } from "react";
import { Form, Button, Row, Col, Spinner, Table } from "react-bootstrap";
import API_BASE_URL from "../../config";
import { authFetch } from "../../utility/authFetch";

function CancelAppointment() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const [loader, setLoader] = useState(false);
  const [query, setQuery] = useState("");
  const [patientList, setPatientList] = useState([]);
  const formRef = useRef(null);

  const CancelRecord = async (id) => {
    try {
      setLoader(true);
      const response = await authFetch(
        `${API_BASE_URL}/api/cancel-patient-appointment?id=${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const result = await response.json();
      if (result.success) {
        alert("Appointment cancelled successfully");
        setQuery("");
        setPatientList([]);
      } else {
        alert("Failed to cancel appointment");
      }
    } catch (error) {
      console.error("Error fetching patient:", error);
      alert("An error occurred while cancelling the appointment");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!query) {
      setPatientList([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      authFetch(`${API_BASE_URL}/api/get-patient-appointments?query=${query}`)
        .then((res) => res.json())
        .then((data) => {
          setPatientList(data.patients);
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [query]);

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5 className="mb-3">Cancel Appointment</h5>

            <Form ref={formRef}>
              <Row className="align-items-end g-3">
                <Col md={12}>
                  <Form.Group className="mb-3" controlId="formPatientName">
                    <Form.Label>
                      Patient Name / Contact Number{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Patient Name or Contact Number"
                      name="name"
                      required
                      autoComplete="off"
                      list="patient-options"
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>

            <Table striped bordered hover>
              <thead>
                <tr>
                  <th style={{ width: "100px" }}>Action</th>
                  <th>Name</th>
                  <th>Contact Number</th>
                  <th>Booking Date</th>
                  <th>Visit Date</th>
                  <th>Doctor</th>
                </tr>
              </thead>
              <tbody>
                {patientList.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No records found
                    </td>
                  </tr>
                ) : (
                  patientList.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <Button
                          variant="danger"
                          onClick={() => {
                            CancelRecord(item.ID);
                          }}
                        >
                          CANCEL
                        </Button>
                      </td>
                      <td>{item.name}</td>
                      <td>{item.contact}</td>
                      <td>{item.bookingDate}</td>
                      <td>{item.visitDate}</td>
                      <td>{item.doctor}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CancelAppointment;
